<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/Logo_DCT.jpg" alt="logo图" />
    </div> -->
    <!-- <p class="title">{{ config.name }}</p> -->
    <!-- <p class="address_tel_fax">
      <span>地址：{{config.address}}</span>
      <span>Tel：{{config.phone}}</span>
      <span>Fax：{{config.tel}}</span>
    </p> -->
    <!-- <p class="email_wx">
      <span>24小时售后服务热线：{{ config.phone }}</span>
    </p> -->
    <div class="text-container">
      <p class="copy">
        版权所有 EDWinXP &copy;
        <span class="align-target"
          >德中（天津）技术发展股份有限公司 （自2020年）</span
        >
      </p>
      <p class="copy1">
        <span class="align-target">Visionics Sweden HB（1983~2019年）</span>
      </p>
      <p class="copy2">
        <span class="align-target">津ICP备12000863号-5</span>
      </p>
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  name: "Footer",
  data() {
    return {
      config: config,
    };
  },
};
</script>

<style scoped>
#footer {
  width: 100%;
  /* height: 100%; */
  color: #fff;
  background: #0d3d78;
  overflow: hidden;
  text-align: center;
}

.logo img {
  max-width: 341px; /* Logo的最大宽度为原始宽度的一半 */
  width: 100%; /* 使用百分比来使宽度自适应容器的宽度 */
  height: auto; /* 高度自动，保持原有宽高比 */
  /* justify-content: center; */
  margin-left: auto;
  margin-right: auto;
}

.logo {
  /* width: 20px;
  height: 10px; */
  max-width: 512px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 15px;
}
.text-container {
  margin-top: 10px;
  position: relative; /* 设定参照点 */
  text-align: center; /* 文本水平居中 */
}

.copy {
  text-align: center; /* 确保文本在其容器内水平居中 */
}

.copy1,
.copy2 {
  position: relative;
  padding-left: 140px;
}

span {
  display: inline-block; /* 使span行为像块元素，但仍然在行内 */
  width: 500px; /* 设置宽度以匹配最长的单个字符序列，保证对齐 */
  text-align: left; /* 确保文本左对齐 */
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue